export default __webpack_public_path__ + "static/media/Sets.1dc35716.jpg";